'use es6';

import { RAW_ASSET as DESIGN_ASSET_TYPE_RAW_ASSET } from 'DesignData/enums/DesignAssetTypes';
import { RAW_ASSET } from 'DesignData/enums/FolderAssetTypes';
import * as ICONS from 'DesignData/constants/Icons';
import * as RawAssetExtensions from 'DesignData/enums/RawAssetExtensions';
import { IMAGE, FONT, TEXT, BINARY } from 'DesignData/enums/RawAssetTypes';
import DesignAssetTypeIcons from 'DesignData/enums/DesignAssetTypeIcons';

function _getFileExtension(path) {
  const idx = path.lastIndexOf('.');
  return idx !== -1 ? path.substring(idx + 1) : '';
}

function _getRawAssetIconFromPath(path) {
  const extension = _getFileExtension(path);

  const {
    type,
    name
  } = RawAssetExtensions[extension] || {};

  switch (type) {
    case IMAGE:
      {
        return ICONS.RAW_ASSET_ICON_MAP.IMAGE;
      }

    case FONT:
      {
        return ICONS.RAW_ASSET_ICON_MAP.FONT;
      }

    case TEXT:
      {
        if (name === RawAssetExtensions.JSON.name) {
          return ICONS.RAW_ASSET_ICON_MAP.JSON;
        } else if (name === RawAssetExtensions.JS.name) {
          return ICONS.RAW_ASSET_ICON_MAP.JS;
        } else if (name === RawAssetExtensions.MD.name) {
          return ICONS.RAW_ASSET_ICON_MAP.MD;
        } else if (name === RawAssetExtensions.GRAPHQL.name) {
          return ICONS.RAW_ASSET_ICON_MAP.GRAPHQL;
        }

        return ICONS.RAW_ASSET_ICON_MAP.DEFAULT;
      }

    case BINARY:
    default:
      {
        return ICONS.RAW_ASSET_ICON_MAP.DEFAULT;
      }
  }
}

export function getIconNameFromFolderAssetType(assetType, path = '') {
  switch (assetType) {
    case RAW_ASSET:
      {
        return _getRawAssetIconFromPath(path);
      }

    case null:
      {
        return ICONS.RAW_ASSET_ICON_MAP.DEFAULT;
      }

    default:
      {
        return ICONS.FINDER_FILE_ICON_MAP[assetType];
      }
  }
}
export function getIconNameFromDesignAssetType(assetType, path = '') {
  switch (assetType) {
    case DESIGN_ASSET_TYPE_RAW_ASSET:
      {
        return _getRawAssetIconFromPath(path);
      }

    default:
      {
        return DesignAssetTypeIcons[assetType];
      }
  }
}